


<!-- ================================================================ -->


<!-- new html -->

<div class="chat-card theme light">

  <!-- ================= HEADER ================= -->
  <div
    class="chat-header d-flex align-items-center border-bottom bg-dynamic position-relative pt-1 pb-1 px-3 w-100">

    <img src="../../../assets/images/dhanushailogo1.PNG"
         alt="DhanushBot Logo"
         class="logo-img me-2">

    <h3 class="mb-0">Dhanush AI</h3>

    <!-- Theme toggle -->
    <div class="d-flex justify-content-center ms-4 ml-4">
      <i class="fa fa-adjust ml-4"
         title="Theme colour"
         (click)="toggleTheme($event)">
      </i>
    </div>

    <!-- Right controls -->
    <div class="d-flex align-items-center position-absolute"
         style="right:15px; top:10px;">
      <!-- Future radio buttons preserved -->
      <!--
      <div class="d-inline-flex align-items-center me-3">
        <input class="form-check-input me-1"
               type="radio"
               name="filters"
               [checked]="selectedMode === 'DB'"
               (click)="toggleMode('DB')" />
        <label class="form-label mb-0">Fetch DB</label>
      </div>
      -->

      <button type="button"
              class="close"
              aria-label="Close"
              (click)="activeModal.dismiss('Cross click')">
        <span>&times;</span>
      </button>
    </div>
  </div>

  <!-- ================= CONTENT ================= -->
  <div class="chat-content">

    <div class="container-fluid h-100">
      <div class="row h-100">

        <!-- ===== SIDEBAR ===== -->
        <div class="col-xl-3 h-100 p-0">
          <div class="chat-sidebar">

            <h6 *ngFor="let report of reportList"
                class="report-item"
                (click)="handleReportClick(report)">
              {{ report }}
            </h6>

            <!-- Conversation history (kept commented as requested) -->
            <!--
            <div *ngFor="let conv of conversationList"
                 class="history-item"
                 (click)="loadConversation(conv.conversation_id)">
              {{ conv.title }}
            </div>
            -->
          </div>
        </div>

        <!-- ===== CHAT BODY ===== -->
        <div class="col-xl-9 h-100 p-0">
          <div class="chat-box" #chatBox>

            <!-- Messages -->
            <div *ngFor="let msg of messages"
                 class="chat-message"
                 [ngClass]="msg.from">

              <div class="chat-icon">
                <ng-container *ngIf="msg.from === 'user'; else botLogo">
                  <img src="https://preclinic.dreamstechnologies.com/html/template/assets/img/users/user-01.jpg"
                       class="chat-user-logo">
                </ng-container>
                <ng-template #botLogo>
                  <img src="../../../assets/images/dhanushailogo1.PNG"
                       class="chat-bot-logo">
                </ng-template>
              </div>

              <div class="message-wrapper">

                <!-- TABLE / HTML -->
                <div *ngIf="isTableHTML(msg.text); else plainText"
                     class="bot-system-message">
                  <iframe class="html-iframe"
                          [srcdoc]="msg.safeHtml"
                          (load)="onIframeLoad($event, msg)"
                           frameborder="0"
                          scrolling="yes">
                  </iframe>
                </div>

                <!-- TEXT -->
                <ng-template #plainText>
                  <div class="message-content"
                       [innerHTML]="msg.text">
                  </div>
                </ng-template>

                <div class="message-label">
                  {{ msg.from === 'user' ? 'You' : 'Dhanush AI' }}
                </div>
              </div>
            </div>

            <!-- Typing indicator -->
            <div *ngIf="isSending"
                 class="chat-message bot loading-message">
              <div class="chat-icon">
                <img src="../../../assets/images/dhanushailogo1.PNG"
                     class="chat-bot-logo">
              </div>
              <div class="message-content typing-dots">
                <span></span><span></span><span></span>
              </div>
            </div>

          </div>
        </div>

      </div>
    </div>
  </div>

  <!-- ================= FILE UPLOAD ================= -->
  <div *ngIf="uploadingFile"
       class="file-upload-progress">
    <div class="progress-animated">
      <div class="progress-bar-animated"
           [style.width.%]="uploadProgress">
      </div>
    </div>
    <small>{{ selectedFile?.name }}</small>
  </div>

  <!-- ================= FOOTER ================= -->
<!-- Input area -->
<div class="floating-action-bar">
  <div class="input-group" style="flex:1; display:flex; align-items:center; gap:8px;">
    
    <!-- Textarea -->
    <textarea *ngIf="!isRecording" class="no-glow" rows="1" [(ngModel)]="userInput" placeholder="Ask anything..."
      (keydown.enter)="sendMessage(); $event.preventDefault();" style="flex:1;">
    </textarea>

    <!-- Dotted waveform animation -->
    <div *ngIf="isRecording" class="dot-wave-container" style="flex:1;">
      <div *ngFor="let dot of dots" class="dot" 
           [style.transform]="'scaleY(' + dot.scale + ')'"
           [style.opacity]="dot.opacity"></div>
    </div>

    <!-- Action buttons (always visible, same layout) -->
    <div class="quick-actions" style="display:flex; gap:8px;">
      <!-- <button class="btn btn-light mic-button" 
              [ngClass]="{'recording-active': isRecording}"
              (click)="toggleVoiceChat()">
        <span class="material-symbols-outlined">{{ isRecording ? 'stop' : 'mic' }}</span>
      </button> -->

      <!-- below not used code -->
      <!-- <button class="btn btn-light" (click)="onUploadClick()" *ngIf="!isRecording">
        <span class="material-symbols-outlined"> attach_file </span>
      </button>
      <button class="btn btn-light" (click)="getHealthTips()" *ngIf="!isRecording">
        <span class="material-symbols-outlined"> medical_services </span>
      </button> -->
      <div class="dropup" *ngIf="!isRecording">
  <!--upload Trigger button -->
  <!-- <button
    class="btn btn-light"
    type="button"
    id="customDropdown"
    data-toggle="dropdown"
    aria-expanded="false"
    style="box-shadow: none;">
    <span class="material-symbols-outlined">more_vert</span>
  </button> -->

  <!-- files Dropdown menu -->
  <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="customDropdown">
    <li>
      <a class="dropdown-item" (click)="onUploadClick()">
        <span class="material-symbols-outlined me-2">attach_file</span>
        Upload File
      </a>
    </li>
    <li>
      <a class="dropdown-item" (click)="getHealthTips()">
        <span class="material-symbols-outlined me-2">medical_services</span>
        Health Tips
      </a>
    </li>
  </ul>
</div>

<!-- Mic Symbol -->

      <!-- <button class="btn btn-light mic-button" 
      [ngClass]="{
        'listening': conversationActive,
        'processing': isProcessing
      }"
      (click)="toggleConversation()" >
     <span class="material-symbols-outlined">{{ conversationActive ? '⏹️' : '🎤' }}</span> 
      </button>
    </div> -->

  </div>

  <button *ngIf="!isRecording" class="btn send-button" (click)="sendMessage()">
    <span class="material-symbols-outlined"> send</span>
  </button>
</div>

  <input type="file"
         #fileInput
         hidden
         (change)="onFileSelect($event)" />

</div>
